import React from "react";
import "../styles/Header.css";

const Header = () => (
  <header className="header">
    <h1 className="header__title">Markdown Previewer</h1>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.js